import type { i18n, TFunction } from 'i18next';
import i18next from 'i18next';
import { mapBundleToResource } from '../../utils/i18next-utils';
import { OneApi } from '../one-api/one-api';

export class TranslationBundles {
  static bundles: { [k: string]: { i18nInstance: i18n; t: TFunction | any; identifier: string } } = {};

  static addBundle(i18nBundle: { i18nInstance: i18n; t: TFunction; identifier: string }): void {
    const { identifier } = i18nBundle;
    TranslationBundles.bundles[identifier] = i18nBundle;
  }

  static t(bundle: string, ...args: any[]): string {
    if (!TranslationBundles.bundles[bundle]) {
      console.warn(`Bundle ${bundle} not defined.`);
      return args[0];
    }
    return TranslationBundles.bundles[bundle].t(...args);
  }

  static async load(args: {
    bundleIdentifier: string;
    bundleId?: string;
    language: string;
    public?: boolean;
  }): Promise<void> {
    if (TranslationBundles.bundles[args.bundleIdentifier]) {
      return;
    }

    const bundle = await TranslationBundles.loadBundle(args);

    const i18nInstance = await TranslationBundles.createI18nInstance(args.language, bundle);
    TranslationBundles.addBundle({
      i18nInstance,
      t: i18nInstance.t,
      identifier: args.bundleIdentifier,
    });
  }

  private static async createI18nInstance(language, bundle) {
    const i18nInstance = i18next.createInstance();

    await i18nInstance.init({
      lng: language,

      interpolation: {
        prefix: '{',
        suffix: '}',
        escapeValue: false,
      },

      resources: mapBundleToResource(bundle, language),
    });
    return i18nInstance;
  }

  private static async loadBundle(args: {
    bundleIdentifier: string;
    bundleId?: string;
    language: string;
    public?: boolean;
  }) {
    if ((window as any)?.sydleApp?.translationBundles) {
      const translationBundle: { [k: string]: { [k: string]: string } } = (window as any)?.sydleApp
        ?.translationBundles?.[args.bundleIdentifier];
      return TranslationBundles.parseSyTranslationBundle(translationBundle, args.language);
    }

    try {
      return await OneApi.translateAPI.getBundle({
        bundleIdentifier: args.bundleIdentifier,
        bundleId: args.bundleId,
        public: args.public,
      });
    } catch (error) {
      console.error('Error to get translation bundle from ONE API\n', error);
      return;
    }
  }

  private static parseSyTranslationBundle(bundle: { [k: string]: { [k: string]: string } }, language: string) {
    const translation: { [key: string]: string } = {};
    Object.keys(bundle).forEach((unit) => {
      // If the language is not defined, try to get the value for the language without the region
      translation[unit] = bundle[unit][language] || bundle[unit][language.substring(0, 2)];
    });
    return translation;
  }
}




 
export const t = TranslationBundles.t;
